// Settings → Plan → Billing: opens the Stripe billing portal (payment method, invoices, cancel).
import React, { useState } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';
import './paymentSetting.css';

const PaymentSetting = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [failed, setFailed] = useState(false);

  const handleManageClick = async () => {
    setIsLoading(true);
    setFailed(false);
    try {
      const { data } = await httpsCallable(getFunctions(), 'manageBilling')();
      window.location.href = data.url;
    } catch {
      setFailed(true);
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="setting-header">Billing</div>
      <div className="account-settings-container">
        <div className="settings-row">
          <div className="settings-label">
            Payment & Subscription
            {failed && <div className="settings-subtitle payment-error">Couldn’t open the billing portal. Please try again.</div>}
          </div>
          <div className="settings-field">
            <button
              type="button"
              className="ui-setting-button"
              onClick={handleManageClick}
              disabled={isLoading}
              aria-busy={isLoading}
            >
              {isLoading ? 'Loading…' : 'Manage'}
            </button>
          </div>
        </div>

        <div className="payment-help">
          <a href="/help/7956855-billing">Need help with billing?</a>
        </div>
        <div className="payment-help">
          <a href="https://bumpups.zapier.app/" target="_blank" rel="noopener noreferrer">Contact us</a>
        </div>
      </div>
    </>
  );
};

export default PaymentSetting;
